import { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react';
import { useAuth } from '../auth/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PresenceContext = createContext({ online: new Set(), isOnline: () => false });

export const PresenceProvider = ({ children }) => {
  const { user } = useAuth();
  const [online, setOnline] = useState(new Set());
  const timer = useRef(null);

  const tick = useCallback(async () => {
    if (!user) return;
    try {
      await fetch(`${API}/presence/ping`, { method: 'POST', credentials: 'include' });
      const res = await fetch(`${API}/presence/online`, { credentials: 'include' });
      if (res.ok) { const d = await res.json(); setOnline(new Set(d.online || [])); }
    } catch { /* offline noop */ }
  }, [user]);

  useEffect(() => {
    if (!user) { setOnline(new Set()); return; }
    tick();
    timer.current = setInterval(tick, 30000);
    return () => clearInterval(timer.current);
  }, [user, tick]);

  const isOnline = useCallback((id) => online.has(id), [online]);
  return <PresenceContext.Provider value={{ online, isOnline }}>{children}</PresenceContext.Provider>;
};

export const usePresence = () => useContext(PresenceContext);

export const OnlineDot = ({ userId, className = '' }) => {
  const { isOnline } = usePresence();
  if (!isOnline(userId)) return null;
  return (
    <span className={`relative inline-flex items-center ${className}`} title="En línea ahora" data-testid={`online-dot-${userId}`}>
      <span className="absolute inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500 opacity-60 animate-ping" />
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-500 ring-2 ring-[#0B0C0E]" />
    </span>
  );
};
